import type { EditorPlugin } from '../../../types/aha-editor';
import ItalicMarkPlugin from './ItalicMarkPlugin';
import ItalicMarkdownPlugin from './ItalicMarkdownPlugin';

const ItalicPlugin: EditorPlugin[] = [ItalicMarkPlugin, ItalicMarkdownPlugin];

export default ItalicPlugin;
